import React from 'react';
import Text from '@ingka/text';
import { useNestedTranslation } from 'hooks/useNestedTranslation';
import classes from './ContractMix.module.scss';

const ContractMixHeader = () => {
    const t = useNestedTranslation('contractMix');

    return (
        <div>
            <Text data-testid="contract-mix-header-title" tagName="h2" textStyle="Heading.M" className={classes['contract-mix__header']}>
                {t('contract_mix_title')}
            </Text>
            <Text data-testid="contract-mix-header-subtitle" tagName="span" textStyle="Body.S" className={classes['contract-mix__description']}>
                {t('contract_mix_subtitle')}
            </Text>
        </div>
    );
};

export default ContractMixHeader;
